import React, {} from 'react';
//import { Link as RouterLink } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import { Button, TextField, Table, LinearProgress,
    TableContainer, TableBody, TableHead, TableRow, TableCell, TablePagination,
    FormControl, Select, MenuItem, InputLabel, Menu, 
    Dialog, DialogTitle, DialogContent,DialogContentText, DialogActions, FormControlLabel, FormLabel, Checkbox
} from '@material-ui/core';
import GearIcon from '@material-ui/icons/SettingsSharp'; 
import FilterIcon from '@material-ui/icons/FilterListSharp'; 
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DownIcon from '@material-ui/icons/ArrowDropUpSharp'; 
import UpIcon from '@material-ui/icons/ArrowDropDownSharp'; 
import PlusIcon from '@material-ui/icons/AddCircleOutlineSharp'
import UploadIcon from '@material-ui/icons/CloudUploadTwoTone';
import './components/styles.scss'
import PropTypes from 'prop-types';
//import { getParameterByName } from '../../utils/utils';
import moment from 'moment';
import apiManager from '../../ApiManager';
import ColumnSettings from './components/ColumnSettings';
import AddUserForm from './components/AddUserForm';

import ColumnData from '../../assets/admin/columnData.json'
import EditProfileDialog from '../../components/EditProfileDialog';
import EditSubscriptionDialog from '../../components/EditSubscriptionDialog'
import { flattenResponse } from '../../utils/flatten'
import { formatExpiration } from '../../utils/utils';
import BulkUploadForm from './components/BulkUploadForm'
import isEmpty from 'lodash/isEmpty'
import { ORGANIZATION_ALIAS } from '../../constants';
import UsageReportDialog from './components/UsageReportDialog';
import RegisterSnackBar from "../SignUpVerification/components/RegisterSnackBar";
import { async } from 'validate.js';
import { supportsHistory } from 'history/DOMUtils';

const styles = (theme) => ({
    root: {
        paddingTop: 116,
        fontFamily: 'Helvetica',
        '@media only screen and (max-width: 450px)': {
            marginLeft: 0,
            paddingTop: 54,
        },
    },
    logo: {
        width: 300,
        margin: '12px auto 54px',
        '@media only screen and (max-width: 450px)': {
            width: 150,
            margin: '12px auto 26px',
        },
    },
    logoimg: {

        flexShrink: 0,
        minWidth: '100%',
        minHeight: '100%',
        maxWidth: '100%'
    },

    table: {
        fontSize: 18,
        '@media only screen and (max-width: 450px)': {
            fontSize: 12,
        }
    },
    headerRow: {
        background: '#67b1e2',
    },
    oddRow: {
        background: '#ccc'
    },
    columnhidemobile: {
        '@media only screen and (max-width: 450px)': {
            display: 'none',
        }
    },
    tc: {

        fontSize: 18,
        '@media only screen and (max-width: 450px)': {
            fontSize: 12,
        }
    },
    tch: {
        fontSize: 18,
        fontWeight: 'bold',
        color: 'white',
        '@media only screen and (max-width: 450px)': {
            fontSize: 12,
        }
    },

    contentarea: {
        paddingLeft: 32,
        paddingRight: 54,
        marginBottom: 54,
        color: '3d3d3d',
        '@media only screen and (max-width: 450px)': {
            paddingLeft: 8,
            paddingRight: 8,
        },
    },

    pageTitle: {
        fontSize: 24,
        color: '#679438',
        padding: 24,
        marginBottom: 8,
    },
    container: {
        minHeight: 640,
      },

      formControl: {
        margin: 0,
        minWidth: 120,
        marginRight: 12,
      },

});

const filterList = {
        // city: [{"Denver": false}, {"Boulder": false}, {"Greeley": false}, { "Ft. Collings": false}, {"Grand Junction": false}],
        // state: [{"CO": false}, {"CA": false}, {"OR": false}, {"WA": false}, {"ID": false}],
        // country: [{"US": false}],
        subscription: [{"Stripe": false}, {"Manual": false}, { "Unsubscribed": false}],
        //registration: [],
        course: [],
        // expiryDate: [{"This week": false}, {"This Month": false}, {"Next Month": false}, {"Expired": false}],
        role: [{"subscriber": false}, {"admin-orgViewer": false}, {"user": false}, {"admin-org": false}],
        membertype:[],   
        membergroup: [], 
        source: [{"Graze Magazine": false}, {"Acres Magazine": false}, {"Narrasys": false}, {"UAg/SHA Newletter": false}, {"UAg/SHA Website": false}],
        referral: [{"direct": false}, {"https://soilhealthacademy.org/": false}, {"uanewsletter113020": false}, {"uanewsletter122120": false}, {"https://kisstheground.com/": false}],

    }

export class Administration extends React.PureComponent {
    constructor(...args) {
        super(...args);

        const { user, apiManager, history } = this.props;

        const pageSizeOptions = [25, 50, 100, 200];
        const pagesMinItems = pageSizeOptions[0];
        const byName = `${user['custom:firstName']} ${user['custom:lastName']}`;

        //     const currentClass = getParameterByName('class');
        this.state = {
            showCount: false,  // set to false to hide row #s
            user, // TODO: Not set yet. Need to adjust 
            apiManager,
            history,
            snack: {
                isOpen: false,
                message: '',
                isSuccessfull: 'success',
            },
            sortBy: 'created-down',
            sortDir: 1,             // 1 is ascending, -1 is descending
            sortByLabel: 'created-down',
            pageSizeOptions,
            pagesMinItems,
            page: 1,
            pageSize: pageSizeOptions[0],
            rowAnchorEl: null,
            rowContext: '',
            openEditDialog: false,
            searchBy: '',
            searchTerm: '',
            openPWDialog: false,
            openSubDialog: false,
            openBulk: false,
            filter: {},
            filterEl: null,

            columns: ColumnData.columns,
            columnEl: null,

            isLoading: true,
            message: '',
            messageStrong: '',
            messageOpen: false,
            adminType: localStorage.getItem('adminType'),
            changePasswordTo: 'changeThisPassword!',
            memberGroups: null,
            memberTypes: null,
            deleteOpen: false,
            confirmMessage: '',
            organization: '',
            courses: '',
            organization: '',
            selectedCourse: '',
            byName,
            showUsageReportDialog: false,

            processingCSV: false,
            csvProgress: 0,
        };
    }

    componentDidMount = async () => {
        // Get the current JWT
        const attributes = await apiManager.currentAttributes();
        const { accessToken, idToken } = await apiManager.currentSession();
        const { payload } = idToken;
        const organization = localStorage.getItem('organization') ? JSON.parse(localStorage.getItem('organization')) : ''

        window.onpageshow = function (event) {
            if (event.persisted) {
                window.location.reload()
            }
        };
        this.setState({
            filter: filterList,
            organization: organization.organization || '',
            courses: organization.courses || []
        }, () => this.getList())

    };

    componentDidUpdate = (prevProps, prevState) => {
        const p = this.props;
        const pp = prevProps;
        const s = this.state;
        const ps = prevState;
    }



    handleNameInput = (event) => {
        event.persist();
        this.setState({ newName: event.target.value });
    };

    handleDeleteInput = (event) => {
        event.persist();
        this.setState({ confirmMessage: event.target.value });
    };
    filterForPayload = (currentFilter) => {
        let updatedFilter = currentFilter;
        Object.keys(updatedFilter).forEach(category => 
            updatedFilter[category] = updatedFilter[category].filter((option, index) => 
                Object.values(option)[0] === true
            ).map(cat => 
               Object.keys(cat)[0]
                )
            )
        return updatedFilter
    }
    getList = async (isDownload, presetFilters = false, excludeAdmins = false) => {
        this.setState({ isLoading: true });
        
        const { page, pageSize, sortBy, sortDir, searchBy, searchTerm, filter, totalUsers } = this.state;

        const filterString = presetFilters || this.filterForPayload({...filter})

        const payload = {
            page, pageSize, sortBy, sortDir, searchBy, searchTerm, filterString, orgAlias: ORGANIZATION_ALIAS
        };
        if(isDownload){
            payload.page = 1;
            payload.pageSize = totalUsers;
        }
        if (excludeAdmins) {
          payload.exclude = 'admins';
        }
        let response;
        if (!isDownload || totalUsers < 250) {
          response = await apiManager.getUserList(payload);
        } else {
          // get the list in pages of no more than 1000;
          payload.pageSize = 250;
          this.setState({csvProgress: 10});
          response = await apiManager.getUserList(payload);
          this.setState({csvProgress: 20});
          let newList = response.list;
          const sets = Math.ceil(totalUsers / 250);
          for( var i=1; i<sets; i++) {
            payload.page++;
            const nextSet = await apiManager.getUserList(payload);
            const progress = 20+(75*(i/sets));
            this.setState({csvProgress: Math.floor(progress)});
            newList = newList.concat(nextSet.list);
          }
          response.list = newList;
        }
       
        const flattenedResponse = flattenResponse(response);
        debugger;
        //now get memberGroups and memberTypes
        response.memberGroups && this.setState({memberGroups: response.memberGroups}) 
        response.memberTypes && this.setState({memberTypes: response.memberTypes})
        if(filter.membergroup.length === 0 || filter.membertype.length === 0) {
            const membertype = [...response.memberTypes].map(type => ({[type]: false}))
            const membergroup = [...response.memberGroups].map(group => ({[group]: false}))
            const updatedFilter = {...this.state.filter, membertype, membergroup }

            this.setState({filter: updatedFilter});
        }

        // GET THE FILTER CATEGORIES FROM BACK END CURRENTLY HARDCODED AS INITIAL STATE
        // data shape [category:[{option: boolean},...]] 
        // if (respone.filterList){
        //     this.setState({filter: filterList})
        // }

        //list = flat object
        if(!isDownload){
        this.setState({ 
            list:  flattenedResponse, 
            totalUsers: page === 1 ? response.count : totalUsers,
            isLoading: false });
        } else {
            this.setState({ 
                isLoading: false });
            return flattenedResponse;
        }
    }

    createNewUser = async (newUser) => {

        // update data: registration, 

        const {byName} = this.state;
        newUser.createdBy = byName;
        let subscriptions = [];
        newUser.registrations = [
            {
                "organization": {
                    "_id": "",
                    "name": ORGANIZATION_ALIAS,
                    "registeredBy": byName,
                    "memberTypes": [
                        "TBD (Default)"
                    ],
                    "group": newUser.memberGroup || '',
                    "referralUrl": "Admin Created User",
                    "referredBy": "Admin",

                    // "subscriptions": [
                    // ]
                }
            }
        ];
        this.state.courses.map((course, index) => {
            if(newUser.subscriptions && newUser.subscriptions[course.alias]){
                subscriptions.push({
                    processedBy: "Manual",
                    subscribedBy: byName,
                    courseNameAlias: course.alias,
                    isSubscribed: true,
                    status: 'active',
                    //active: true,
                    startDate: moment().valueOf(),
                    endDate: moment().add(1, 'y').valueOf(),
                })
            } else {
                subscriptions.push({
                    processedBy: "Manual",
                    subscribedBy: byName,
                    courseNameAlias: course.alias,
                    isSubscribed: false,
                    status: 'inactive'
                    //active: true,
                })
            }
        })
        newUser.registrations[0].organization.subscriptions = subscriptions;
        console.log(newUser);

        const response = await apiManager.adminCreateUser(newUser);
        let message =` User Created! `
        let messageStrong = `Please contact the user with this information. Username ${newUser.email} / Password: ${newUser.password}`
        let error = false;
        if (!response || !response.data || !response.data.newUser || response.data.newUser.error === true) {
            message = `User not created. Error: ${!response || !response.data ? 'service error' : response.data.newUser.message}`;
            messageStrong = '';
            error = true;
        }
        this.setState({ messageOpen: true, message, messageStrong, error });

        if (!error) {
            this.setState({openAdd: false});
            this.setState({page: 1}, () => {
                this.getList();
               })
        }
    }

    openAddUser = () => {
        this.setState({openAdd: true});
    }

    openBulk = () => {
        this.setState({openBulk: true})
    }
    
    closeBulk = () => {
        this.setState({openBulk: false})
    }

    // ********* close add user: closes the add user dialog and optionally creates the new user
    closeAddUser = async (data = false) => {
 
        if( data && data.data) {
            await this.createNewUser(data.data);
        } else {
            this.setState({openAdd: false});
        }
    }

    openDownloadCsvDialog = csvString => {
     const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

      const date = moment().format('YYYY-MM-DD');
      const downloadName = `User Data - ${date}.csv`
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, downloadName);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', downloadName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    };

    startDownloadCSV = async(filterString = false, excludeAdmins = false) => {
      this.setState({processingCSV: true, csvProgress: 0});
        let data = await this.getList(true, filterString, excludeAdmins);
        const filteredColumns = (filterString && excludeAdmins) ? ColumnData.columns.filter(el => el.progressReport) : ColumnData.columns.filter(el => el.show) ;
        const headers = filteredColumns.map(el => el.label);
        const match =  filteredColumns.map(el => el.id);
        const cd = ColumnData;
        debugger;

        let sub = [...this.state.courses].map(el => ({alias: el.alias, name: el.name, subscribed: false, processedBy: ''}));
        if(sub.length>0) {
          // need to add in additional subscription and expiry and progress
          const startedIndex = headers.indexOf('Started');
          const progressIndex = headers.indexOf('Progress');
          const expiryIndex = headers.indexOf('Expiration');
          const subIndex = headers.indexOf('Subscribed');
          headers[expiryIndex] = `${sub[0].alias} Expiration`;
          headers[subIndex] = `Subscribed: ${sub[0].alias}`;
          headers[startedIndex] = `${sub[0].alias} Started`;
          headers[progressIndex] = `${sub[0].alias} Progress`;

          const mexpiryIndex = match.indexOf('expiry');
          const msubIndex = match.indexOf('subscribed');
          const mstartedIndex = match.indexOf('started');
          const mprogressIndex = match.indexOf('progress');
          if(mexpiryIndex >= 0) {
            match[mexpiryIndex] = `${sub[0].alias} Expiration`;
          }
          if(mstartedIndex >= 0) {
            match[mstartedIndex] = `${sub[0].alias} Started`;
          }
          if(mprogressIndex >= 0) {
            match[mprogressIndex] = `${sub[0].alias} Progress`;
          }          
          if(msubIndex) {
            match[msubIndex] = `Subscribed: ${sub[0].alias}`
          }
          if(expiryIndex >= 0 || subIndex >=0) {
            let firstIndex = progressIndex >= 0 ? mprogressIndex : subIndex;
            let firstMIndex = mprogressIndex >= 0 ? mprogressIndex : msubIndex; 
            let firstSIndex = mstartedIndex >= 0 ? mstartedIndex : startedIndex;
            let firstPIndex = mprogressIndex >= 0 ? mprogressIndex : progressIndex;
             
            for(let i=1; i<sub.length; i++) {
              if(subIndex >= 0) {
                headers.splice(++firstIndex, 0, `Subscribed: ${sub[i].alias}`);
              }
              if(expiryIndex >=0 ) {
                headers.splice(++firstIndex, 0,`${sub[i].alias} Expiration`)
              }
              if(startedIndex >=0 ) {
                headers.splice(++firstIndex, 0,`${sub[i].alias} Started`)
              }
              if(progressIndex >=0 ) {
                headers.splice(++firstIndex, 0,`${sub[i].alias} Progress`)
              }
              if(msubIndex >= 0) {
                match.splice(++firstMIndex, 0, `Subscribed: ${sub[i].alias}`);
              }
              if(mexpiryIndex >=0 ) {
                match.splice(++firstMIndex, 0,`${sub[i].alias} Expiration`)
              }
              if(mstartedIndex >=0 ) {
                match.splice(++firstMIndex, 0,`${sub[i].alias} Started`)
              }
              if(mprogressIndex >=0 ) {
                match.splice(++firstMIndex, 0,`${sub[i].alias} Progress`)
              }
            }
          }
        }
      
        data.forEach((row, index) => {
 
          if (row.name_fullName === 'Cindy Lair') {
            debugger;
          }
          if (row.name_fullName === 'Lealand Schoon') {
            debugger;
          }
          // clear out subscriptions first
          sub.map((el, j) => {
            // default: empty strings!
            sub[j].subscribed = '';
            sub[j].endDate = '';
            sub[j].started = '';
            sub[j].progress = '';
          })
          if(row.organization_subscriptions && row.organization_subscriptions.length > 0 ){
            row.organization_subscriptions.map((userSub, i) => {
                sub.map((el, j) => {
                    if(userSub.courseNameAlias === el.alias){
                      sub[j].started = '';
                      sub[j].progress = '';
                      let status = '';
                       if(!userSub.status) {
                         const r = row;
                         console.log('no sub status', r);
                         let status = userSub.isSubscribed ? 'Active' : 'Inactive';
                         if(status === 'Inactive' && !userSub.endDate) {
                           status = 'Canceled';
                         }
                         sub[j].subscribed = status === 'Active' ? userSub.processedBy : `${status} (${userSub.processedBy})`
                         sub[j].endDate =  userSub.endDate;
                         if (status === 'Active') {
                          sub[j].started = 'none';
                          sub[j].progress = '';
                         }
                       } else {
                     //   console.log(userSub.courseNameAlias, el.alias, sub[j].subscribed, userSub.isSubscribed)
                        status = userSub.status[0].toUpperCase() + userSub.status.slice(1).toLowerCase();
                        if(status === 'Inactive') {
                          sub[j].subscribed = '';
                          sub[j].endDate = '';
                        } else {
                        sub[j].subscribed = status === 'Active' ? userSub.processedBy : `${status} (${userSub.processedBy})`
                        sub[j].endDate =  userSub.endDate;
                        }
                       }
                       if (userSub.progress && userSub.startDate) {
                         const progressArray = userSub.progress || [];
                          let p = 0;
                          let s = [];
                          let startedTotal = 0;
                          userSub.progress.forEach((prog, index) => {
                            p += prog;
                            if (prog && prog > 0) {    
                              s.push(index + 1);
                              startedTotal += 1;
                            }
                          });
                          const progPercent = (p / userSub.progress.length);
                          sub[j].progress =  progPercent > 99.5 ? 'Course Completed' : `${progPercent.toFixed(1)}%`;
                          if (s.length > 0) {
                            sub[j].started = (progPercent > 99.5) || startedTotal === userSub.progress.length ? 'All' : `${s.join(',')}`;
                          } else {
                            sub[j].started = 'none';
                            sub[j].progress = '';
                          }
                       } else if (status === 'Active') {
                        sub[j].started = 'none';
                        sub[j].progress = '';
                       }
                        
                    }
                })
            })
        } else {
          // no subscriptions array!
          sub.map((el, j) => {
            sub[j].subscribed = '';
            sub[j].endDate = '';
            sub[j].started = '';
            sub[j].progress = '';
          })
        }
        sub.map(el => {
          data[index][ `Subscribed: ${el.alias}`] = el.subscribed ? el.subscribed : '';
          data[index][`${el.alias} Expiration`] = el.endDate && el.subscribed ? formatExpiration(el.endDate) : '';
          data[index][`${el.alias} Started`] = el.started;
          data[index][`${el.alias} Progress`] = el.progress;
        })
            // if (row.organization_subscriptions && row.organization_subscriptions.length > 0){
            // data[index] = 
            // {   ...row, 
            //     subscribed: `${row.organization_subscriptions[0].processedBy || 'Stripe'} subscription`,
            //     expiry: moment(row.organization_subscriptions[0].endDate * 1000).format('MM/DD/YYYY')
            // }
            // }
            // else {
            //     data[index] = {...row, subscribed: "No subscription data", expiry: "n/a"}
            // }

            if(row.createdAt && row.updated && row.lastLogin ){
                data[index] = {...row, createdAt: moment(row.createdAt).format('MM/DD/YYYY'), updated: moment(row.updated).format('MM/DD/YYYY'), lastLogin: moment(row.lastLogin).format('MM/DD/YYYY')}
            } else {
              data[index] = {...row, createdAt: moment(row.createdAt).format('MM/DD/YYYY'), updated: moment(row.updated).format('MM/DD/YYYY'), lastLogin: 'never'}
            }
        })
        if (data) {
            data = data.map(row => match.map(key =>row[key]))
            data.unshift(headers);
            // let lines = "data:text/csv;charset=utf-8,"
            let lines = '';
            for(let i=0; i < data.length; i++){
                let line = '';
                for(let value in data[i]){
                   if(line === '') {
                     if(i=== 0) {
                       line = 'index';
                     } else {
                      line += i;
                     }
                   
                   }
                   line += ','
                   let cell = data[i][value]
             
                   if(typeof cell === 'object'){
                       if(cell) {
                        cell = cell.join(' | ')
                       }
                   }
                   if(cell != '' && cell != null){
                    //  cell = cell.toString().replace(/,/g, '').replace(/#/g, '%23');
                    cell = `"${cell.toString().replace(/#/g, '%23')}"`;
                   }
                   if(cell === undefined || cell === null){
                       cell = ''
                   }
                   line += cell
                   
                }
                lines += line + '\r\n'
            }
            this.setState({processingCSV: false});
            this.openDownloadCsvDialog(lines);
            // let encoded = encodeURI(lines)
            // debugger;
            //to do: name file
            // window.open(encoded)
        
        }
    }

    callbackDownloadCSV = async(filterString) => {
      this.startDownloadCSV(filterString, true);  // true = exclude admins
    }

    startUploadUserList = async() => {
        this.setState({openBulk: true})
    }

    handleChangePage = (event, newPage) => {

        this.setState({page: newPage+1}, () => {
            this.getList();
        });
     
    };
    
    handleChangeRowsPerPage = (event) => {
       // setRowsPerPage(+event.target.value);

       this.setState({page: 1, pageSize: +event.target.value}, () => {
        this.getList();
       })

    };

    handleSearchByChange = (event) => {
        this.setState({searchBy: event.target.value, searchTerm: ''});
    }

    handleSearchTermChange = (event) => {
        const value = event.target.value;

        this.setState({searchTerm: event.target.value});
    }

    handleSearchBlur = () => {
        this.setState({page: 1}, () => {
            this.getList();
           })
    }

    handleSearchKeyUp = (event) => {
        if (event.keyCode === 13) {
            // Cancel the default action, if needed
            event.preventDefault();
            // Trigger the button element with a click
            this.handleSearchBlur();
          }
    }

    handleSortBy = (event) => {

      const value = event.target.value.split('-');
        this.setState({sortByLabel: event.target.value , sortBy: value[0], sortDir: value[1] === 'up' ? 1 : -1, page: 1}, () => {
            this.getList();
           })
    }

    closeSnack = async () => {
        this.setState({snack: {isOpen: false, isSuccessful: true, message: "" }});
        this.closeBulk(false)
    };

    openSnack = async (isSuccessfull, message) => {
        this.setState({snack: {isOpen: true, isSuccessfull, message }});
    };

    setColumnOpen = (event) => {
        this.setState({columnEl: event.currentTarget }) 
    }

    setColumnClose = () => {this.setState({columnEl: null})};

    updateColumns = (newColumns) => {
        const { columns } = this.state;
        columns.forEach((column, index) => {
            const show = newColumns[index].show;
            column.show = show;
        })
        this.setState({columnEl: null, columns });
    }

    setFilterOpen = (event) => {
        this.setState({filterEl: event.currentTarget }) 
    }

    setFilterClose = () => {
        this.setState({
            page: 1,
            filterEl: null
        }, () => {
            this.getList();
           })
    };
    clearFilters = () => {
        let clearedFilters = {...this.state.filter}
        //set everything to false
        Object.keys(clearedFilters).forEach(category => {
            clearedFilters[category] = clearedFilters[category].map(option => (
                {[Object.keys(option)[0]]: false }
            ))
        })
        this.setState({filter: clearedFilters})
    }
    handleFilterSelect = (e, group, index) => {
        let updated= [...this.state.filter[group]]
        updated[index] = {[e.currentTarget.name]: !Object.values(updated[index])[0]}
        this.setState({
            filter: {...this.state.filter, [group]: updated}
        })
    }
    handleClose = () => {
        this.setState({openEditDialog: false, openSubDialog:false, rowContext: null, rowAnchorEl: null})
    }
    openRowMenu = (e, row) => {

        this.setState({rowAnchorEl: e.currentTarget, rowContext: row});
    }

    closeRowMenu = () => {
        this.setState({rowAnchorEl: null, rowContext: null});
    }

    editProfile = () => {
        this.setState({openEditDialog: true})
    }

    editSubscription = () => {
        this.setState({openSubDialog: true})
    }

    //PW Reset
    openResetPW = (user) => {
        this.setState({openPWDialog: true})
    }

    handlePWClose = () => {
        this.setState({openPWDialog:false});
        this.handleClose();
    }

    // impersonate
    impersonate = (course) => {
      const row = this.state.rowContext;
      const url = `myclasses?course=${course}&im=${row.cognitoId}`;
      this.state.history.push(url);
    }

    // isSubscribed?
    isSubscribed = (course) => {
      let subscribed = false;
      const row = this.state.rowContext;
      if(row && row.organization_subscriptions && row.organization_subscriptions.length > 0) {
        row.organization_subscriptions.forEach(sub => {
          if(sub.isSubscribed && sub.isSubscribed === true && sub.courseNameAlias === course) {
            subscribed = true;
          }
        })
      }
      return(!subscribed);
    }    
    updateProfile = async (updatedData, moreData) => {

        const {byName} = this.state;

        const payload = {...updatedData, ...moreData}
        payload.updatedBy = byName;
        payload.originalEmail = this.state.rowContext.email; // in case email changed, need this to find the user in cognito
        payload.organization_name = ORGANIZATION_ALIAS;
        if(payload.roles){
            payload.roles_0 = payload.roles[0] || '';
            delete payload.roles
        }
        console.log(payload);
        let response;
        response = await apiManager.adminUpdateUserProfile(payload);
        let message = "User profile updated."
        let messageStrong = '';
        let error = false;
        if(!response || !response.data || response.data.error === true){
            message = `User update failed. Error: ${!response || !response.data ? 'service error' : response.data.message}`;
            error=true
        } else {

            this.handleClose();
            this.setState({ page: 1 }, () => {
                this.getList();
            })
        }
        this.setState({messageOpen: true, message, messageStrong, error })
    }
    updateSubscription = async (updatedSubscription, updatedExpiration) => {
        const payload = {...this.state.rowContext, organization_subscriptions: updatedSubscription};
        console.log(payload.organization_subscriptions)
        this.handleClose();
        let response;
        response = await apiManager.adminUpdateSubscription(payload);
        let message = "User subscription updated."
        let messageStrong = '';
        let error = false;
        if(!response || !response.data || response.data.error === true){
            message = `User subscription update failed. Error: ${!response || !response.data ? 'service error' : response.data.message}`;
            error=true
        }
         if (!error) {
            this.setState({isLoading: true, deleteOpen: false, page: 1}, () => {
                this.handleClose();
                this.getList();
               })
        }
        this.setState({messageOpen: true, message, messageStrong, error })
   
    }
    resetPW = async (email) => {
        this.handlePWClose();
        const response = await apiManager.adminChangePassword({email, password: this.state.changePasswordTo})
        let message =` Password updated! `
        let messageStrong = `Please contact the user with this information. Username ${email} / New Password: ${this.state.changePasswordTo}`;
        let error = false;
        if (!response || !response.data || response.data.error === true) {
            message = `Password not updated. Error: ${!response || !response.data ? 'service error' : response.data.message}`;
            messageStrong = '';
            error = true;
        }
        this.setState({ messageOpen: true, message, messageStrong, error });
    }
    doDeleteUser = async () => {
 
        const payload = {...this.state.rowContext};

        let name = this.state.rowContext.name && this.state.rowContext.name.fullName ? this.state.rowContext.name.fullName : this.state.rowContext.email;
        let response;
    
        response = await apiManager.adminDeleteUser(payload);
        let message = `User ${name} was deleted.`
        let messageStrong = '';
        let error = false;
        if(!response || !response.data || response.data.error === true){
            message = `User deletion failed. Error: ${!response || !response.data ? 'service error' : response.data.message}`;
            error=true
        }
         if (!error) {
            this.handleClose();
            this.setState({page: 1}, () => {
                this.getList();
               })
        }
        this.setState({messageOpen: true, message, messageStrong, error })
   
    }

    openDeleteUser = () => {
        this.setState({deleteOpen: true, confirmMessage: ''});
    }

    handleDeleteClose = () => {
        this.setState({deleteOpen: false, confirmMessage: ''});
    }

    openMessage = (message) => {
        this.setState({messageOpen: true, message});
    }

    closeMessage = () => {
        this.setState({messageOpen: false});
    }
                   
    renderMoreButton = row => {        
        return(
            <div>
                <Button onClick={e => this.openRowMenu(e, row)} style={{marginLeft: -32}}>
                    <MoreVertIcon />
                </Button>
            
        </div>    
        )
    }

    renderName = (row, id) => {
        // const email = row.email.split('@');
        // const names = row.name && row.name.firstName && row.name.lastName ? `${row.name.firstName} ${row.name.lastName}` : `${email[0]} ${email[1]}`;
        return (
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", }}>
           {this.state.adminType !== 'admin-orgViewer' && this.renderMoreButton(row)}
            <span>{row.name_fullName || ' '}</span>
            </div>
        )
    }

    renderByField = (row,id) => {
        const field = id;
        let value = row[field];
        if(typeof value === 'object'){
          if(value) {
           value = value.join(' | ')
          }
      }
        return (
            <div>{value}</div>
        )
    }

    renderRoles = row => {
        // const role = row.roles && row.roles.length > 0 ? row.roles.join(', ') : 'user';

        let role = 'user';

        if( row.roles_0 && row.roles_0.includes('admin')) {
          role = 'ADMIN';
        }
        return (
            <div>
                {role}
            </div>
        )
    }

    renderDate = (row,id) => {
        let field = id;
        if( !row[id]) {
            if( row['created']) field = 'created';
            if( row['createdAt']) field = 'createdAt';
        }
        let date = moment(row[field]).format('MM/DD/YYYY');
        if(date.includes('1970')) {
            date = moment(row[field]*1000).format('MM/DD/YYYY');
        }
        return (
            <div>{date}</div>
        )
    }

    renderSubscription = (row,id) => {
        let sub = [...this.state.courses].map(el => ({alias: el.alias, name: el.name, subscribed: false, processedBy: ''}));
        if(row.organization_subscriptions && row.organization_subscriptions.length > 0 ){
            row.organization_subscriptions.map((userSub, i) => {
                sub.map((el, j) => {
                    if(userSub.courseNameAlias === el.alias){
                        //console.log(userSub.courseNameAlias, el.alias, sub[j].subscribed, userSub.isSubscribed)
                      sub[j].subscribed = userSub.isSubscribed
                      if (userSub.status === 'inactive') {
                        sub[j].processedBy = '';
                        sub[j].status = '';
                      } else {
                        sub[j].processedBy = userSub.processedBy
                        sub[j].status = userSub.status
                      }
                    }
                })
            })
        }
        return (
            <>
            {sub.map(el => 
                <div>
                  <span style={{fontWeight: el.subscribed ? 600 : 300, textTransform: 'capitalize'}}>{el.name}: {el.status ? el.status : el.subscribed ? 'active' : ''} {el.processedBy ? `(${el.processedBy})` : '—'} 
                  </span>
                  </div>
            )}
            </>
        )
    }

    renderProgress = (row,id) => {
      let prog = [...this.state.courses].map(el => ({alias: el.alias, name: el.name, subscribed: false, progress: 0, started: 'none'}));
      if(row.organization_subscriptions && row.organization_subscriptions.length > 0 ){
          row.organization_subscriptions.map((userSub, i) => {
              prog.map((el, j) => {
                  if(userSub.courseNameAlias === el.alias){
                    prog[j].subscribed = userSub.isSubscribed;
                    prog[j].progressArray = userSub.progress || [];
                    if (userSub.progress) {
                      let p = 0;
                      let s = [];
                      userSub.progress.forEach((prog, index) => {
                        p += prog;
                        if (prog && prog > 0) {
                          
                          s.push(index + 1);
                        }
                      });
                      prog[j].progress = p / userSub.progress.length;
                      if (s.length > 0) {
                        prog[j].started = s.join(',');
                      }
                    }
              
                  }
              })
          })
      }
      return (
          <>
          {prog.map(el => 
              <div>
                  {el.progress > 99.5
                  ?
                  <b>Completed<br /></b>
                :
                <span>  {el.started !== 'none' ? `${el.progress.toFixed(1)}%` : ''}<br /></span>
                }
                </div>
          )}
          </>
      )
  }

  renderStarted = (row,id) => {
    let prog = [...this.state.courses].map(el => ({alias: el.alias, name: el.name, subscribed: false, progress: 0, started: 'none'}));
    if(row.organization_subscriptions && row.organization_subscriptions.length > 0 ){
        row.organization_subscriptions.map((userSub, i) => {
            prog.map((el, j) => {
                if(userSub.courseNameAlias === el.alias){
                  prog[j].subscribed = userSub.isSubscribed;
                  prog[j].progressArray = userSub.progress || [];
                  if (userSub.progress) {
                    let p = 0;
                    let s = [];
                    userSub.progress.forEach((prog, index) => {
                      p += prog;
                      if (prog && prog > 0) {
                        
                        s.push(index + 1);
                      }
                    });
                    prog[j].progress = p / userSub.progress.length;
                    if (s.length > 0) {
                      prog[j].started = s.join(',');
                    }
                  }
            
                }
            })
        })
    }
    return (
        <>
        {prog.map(el => 
            <div>
              {el.progress > 99.5
              ?
              <b>All</b>
              :
              <span>
              {el.started} 
              </span>
              }

              </div>
        )}
        </>
    )
}

    renderExpiry = (row, id) => {
        // const endDate = row.organization_subscriptions && row.organization_subscriptions.length > 0 && row.organization_subscriptions[0].endDate;
        // return (
        //     <div>{formatExpiration(endDate)}</div>
        // )
        let sub = [...this.state.courses].map(el => ({alias: el.alias, name: el.name, subscribed: false, processedBy: ''}));
        if(row.organization_subscriptions && row.organization_subscriptions.length > 0 ){
            row.organization_subscriptions.map((userSub, i) => {
                sub.map((el, j) => {
                    if(userSub.courseNameAlias === el.alias){
                        //console.log(userSub.courseNameAlias, el.alias, sub[j].subscribed, userSub.isSubscribed)
                        sub[j].subscribed = userSub.isSubscribed
                        sub[j].processedBy = userSub.processedBy
                        sub[j].endDate =  userSub.endDate;
                    }
                })
            })
        }
        return (
            <>
            {sub.map(el => 
                <div>
                  <span style={{fontWeight: el.subscribed ? 600 : 300}}>
                    {el.name}: {el.endDate ? formatExpiration(el.endDate) : '—'}
                    </span>
                  </div>
            )}
            </>
        )
    }
    renderCell = (row, id) => 
        {
        switch (id) {
            case 'name_fullName':
                return (this.renderName(row,id));
            case 'created':
            case 'createdAt':
              {
                return(this.renderDate(row, id))
            }
            case 'lastLogin':
            {
                return(this.renderDate(row, id))
            }
            case 'updated':
                {
                    return(this.renderDate(row, id))
                }
            case 'subscribed':
                return(this.renderSubscription(row,id));
            case 'expiry': 
                return(this.renderExpiry(row,id));
            case 'started':
                return(this.renderStarted(row,id));
            case 'progress':
                  return(this.renderProgress(row,id));            case 'roles_0':
                return (this.renderRoles(row, id));
            // case 'emails':
            //     return (this.renderEmails(row));
            default:
                return (this.renderByField(row,id))
        }
    }

    renderColumnSettings = () => {
        const { classes } = this.props;
        return (
            <>
                <Button aria-controls="column settings" aria-haspopup="true" onClick={this.setColumnOpen}>
                    <GearIcon /> &nbsp; Columns
                </Button>
                {this.state.columnEl && (
                <Menu
                    id="column-settings-menu"
                    anchorEl={this.state.columnEl}
                    keepMounted
                    open={Boolean(this.state.columnEl)}
                    onClose={this.setColumnClose}
                >
                    <ColumnSettings originalColumns={this.state.columns} cancel={this.setColumnClose} updateColumns={this.updateColumns}/>
                </Menu>
                )}
            </>
        )
    }

    renderSortBy = () => {
        const {classes} = this.props;
        const sortSelections = [];
        this.state.columns.filter(c => c.show && c.sortable).map((column) => {
            
            sortSelections.push(
                {id: column.id +'-up', label: column.label, icon: <DownIcon style={{marginTop: -10}} />}
            )
            sortSelections.push(
                {id: column.id +'-down', label: column.label, icon: <UpIcon style={{marginTop: -10}}/>}
            )
        });
        return(
            <>
                <FormControl className={classes.formControl}>
                                    <Select
                                        labelId="sortBy"
                                        id="sortBy"
                                        value={this.state.sortByLabel}
                                        onChange={this.handleSortBy}
                                        className={classes.selectEmpty}
                                        style={{width: 200}}
                                    >
                                        {/* <MenuItem value={sortSelections[0]}><i>Sort By...</i></MenuItem> */}
                                        {sortSelections.map((column) => (
                                                <MenuItem value={column.id} key={column.id}>{column.label} {column.icon}</MenuItem>
                                        ))}
                                      
                                    </Select>
                                </FormControl>
            </>
        )
    }

    renderMessage = () => {
        const { messageOpen, message, messageStrong} = this.state;

        return(
            <>
            <Dialog open={messageOpen} onClose={this.closeMessage} aria-labelledby="system-message">
            <DialogTitle id="System Message">
                <b>
                {this.state.error
                ? <span style={{color: 'red'}}>There was a problem:</span>
                : <span>Success</span>
                }
                
                </b>
                </DialogTitle>
            <DialogContent>
                <DialogContentText style={{ minWidth: 240 }}>
                    <p> {message} </p>
                    {messageStrong && messageStrong !== '' && (
                        <span style={{ fontWeight: 'bold' }}>
                            <p style={{ color: 'red', margin: 18}}>
                                PLEASE READ:
                            </p>
                            <p style={{margin: 18}}>{messageStrong}</p>
                        </span>
                    )}

              </DialogContentText>
                
               
            </DialogContent>
            <DialogActions>
              <Button onClick={this.closeMessage} color="primary">
                Close
                </Button>
            </DialogActions>
          </Dialog>
          </>
        )
    }
    handleCourseChange = e => {
        this.setState({
            selectedCourse: e.target.value,
            filter: {...this.state.filter, course: e.target.value ? [{[e.target.value]: true}] : [] }
        }, () => this.getList())
    }
    renderCourseSelect = () =>{
        return(
            <FormControl variant="outlined" >
                <InputLabel shrink id="course-select-label" style={{transform: 'translate(0px, -15px)'}}>Course Select</InputLabel>
                <Select
                labelId="course-select-label"
                id="course-select"
                value={this.state.selectedCourse || ""}
                onChange={this.handleCourseChange}
                label="Course Select"
                displayEmpty
                style={{marginTop: 4, height: 30}}
                >
                <MenuItem value="">
                    <em>All Courses</em>
                </MenuItem>
                {!isEmpty(this.state.courses) && this.state.courses.map(course => 
                    <MenuItem value={course.alias}>{course.name}</MenuItem>
                )}
                </Select>
            </FormControl>
        )
    }
    render() {
        const { classes, user } = this.props;
        const { list, page, pageSizeOptions, pageSize, columns, totalUsers, filter } = this.state;
        const pages = Math.ceil(totalUsers / pageSize);

        // console.log('SES: ', this.state);
        const { isSubscribed, isLoading } = this.state;

      


        return (
            <div id="admin-page" className={classes.root}>
                <div className="admin__header">
                    <h2>Administration: User Data</h2>
                    <div style={{marginRight: 15, display: "inline-flex"}}>
                        {this.renderCourseSelect()}
                        {this.renderColumnSettings()}
                        <Button 
                            variant="contained" 
                            size="small" 
                            color="primary" 
                            style={{marginLeft: 18, height: 30}}
                            onClick={() => {this.startDownloadCSV()}}
                        >
                                Download
                        </Button>
                        <Button 
                            variant="contained" 
                            size="small" 
                            color="primary" 
                            style={{marginLeft: 18, height: 30}}
                            onClick={() => {this.setState({showUsageReportDialog: true})}}
                        >
                                Usage Report
                        </Button>
                    </div>
                </div>
                <div className={classes.contentarea}>
                            {/* controllers: search, filter, column settings} */}
                            <div className={classes.controlBlock}>

                                {/* SEARCH BY */}
                                <FormControl className={classes.formControl}>
                                    <InputLabel shrink >Search By</InputLabel>
                                    <Select
                                        value={this.state.searchBy}
                                        onChange={this.handleSearchByChange}
                                        displayEmpty
                                        className={classes.selectEmpty}
                                        inputProps={{ 'aria-label': 'Search By' }}
                                        label={'Search By'}
                                    >
                                         <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value={'name'}>Name</MenuItem>
                                        <MenuItem value={'email'}>Email</MenuItem>
                                        <MenuItem value={'city'}>City</MenuItem>
                                        <MenuItem value={'state'}>State</MenuItem>
                                        <MenuItem value={'country'}>Country</MenuItem>
                                    </Select>
                                </FormControl>
                                {/* SEARCH TERM */}
                                <FormControl className={classes.formControl}>
                                    <TextField
                                        id="filled-search"
                                        label={'Search For...'}
                                        type="search"
                                        onChange={this.handleSearchTermChange}
                                        onBlur={this.handleSearchBlur}
                                        onKeyUp={this.handleSearchKeyUp}
                                        disabled={this.state.searchBy === ''}
                                    />
                                </FormControl>
                                {/* SORT BY */}
                            

               

                   {/* COLUMN SETTINGS */}

                                <div style={{ display: 'inline-block', float: 'right' }}>
                               
                                </div>
                   {/* Filter SETTINGS */}

                                <div style={{ display: 'inline-block', paddingTop:12}} >
                                    <Button aria-controls="column settings" aria-haspopup="true" onClick={this.setFilterOpen}>
                                        <FilterIcon /> &nbsp; Filter
                                    </Button>
                                    <Menu
                                        id="column-settings-menu"
                                        anchorEl={this.state.filterEl}
                                        keepMounted
                                        open={Boolean(this.state.filterEl)}
                                        onClose={this.setFilterClose}
                                        className="filter-menu"
                                    >
                                    
                                        {Object.keys(filter).filter(el => el !== 'course').map((setting, index) => 
                                            <FormControl key={setting}>
                                                <FormLabel>{setting}</FormLabel>
                                                {filter[setting].map((option, optionIndex) => 
                                                <FormControlLabel 
                                                    control={
                                                        <Checkbox 
                                                            checked={Object.values(option)[0]} 
                                                            name={Object.keys(option)[0]} 
                                                            onChange={e => this.handleFilterSelect(e, setting, optionIndex)}
                                                            />}
                                                    label={Object.keys(option)[0]}
                                                    key={Object.keys(option)[0]}
                                                />
                                                )}
                                            </FormControl>
                                        )}
                                        <div className="buttonHolder">
                                            <Button
                                            onClick={this.clearFilters}
                                            variant="text"
                                            className="clear-button">
                                                    Clear Filters
                                            </Button>
                                            <Button
                                            onClick={this.setFilterClose}
                                            variant="outlined">
                                                Apply Filter
                                            </Button>
                                        </div>
                                    </Menu>
                                    {/* <Menu
                                        id="column-settings-menu"
                                        anchorEl={this.state.filterEl}
                                        keepMounted
                                        open={Boolean(this.state.filterEl)}
                                        onClose={this.setFilterClose}
                                    >
                                        <MenuItem onClick={this.setColumnClose}><i>Coming Soon.</i></MenuItem>
                                    
                                    </Menu> */}
                                </div>
                            </div>

                            {/* add user, pagination and sorting */}
                            <table style={{width: '100%', margin: 'auto'}}>
                                <tr>
                                    <td style={{ width: 280, paddingTop: 12 }}>
                                        {this.state.adminType !== 'admin-orgViewer' && (
                                            <>
                                        <Button
                                            // variant="outlined"
                                            color="primary"
                                            size="small"
                                            onClick={this.openAddUser}
                                        >
                                            <PlusIcon />&nbsp; Add User
                                            </Button>
                                        <Button
                                            // variant="outlined"
                                            color="primary"
                                            size="small"
                                            onClick={this.startUploadUserList}
                                        >
                                            <UploadIcon />&nbsp; Upload Users
                                            </Button>
                                            </>
                                        )}
                                    </td>
                            <TablePagination
                                    rowsPerPageOptions={pageSizeOptions}
                                    // component="div"
                                    style={{textAlign: 'center', paddingBottom: 0}}
                                    count={totalUsers}
                                    rowsPerPage={pageSize}
                                    page={page - 1}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                                <td style={{width: 100, paddingTop: 20}}>
                                    {this.renderSortBy()}
                                </td>
                                </tr>
                            </table>
                            {isLoading
                        ?
                        <div style={{ minHeight: 800, width: '100%' }}>
                            <LinearProgress />
                        </div>
                        :
                        <span>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                          {this.state.showCount && (
                                             <TableCell
                                                            key={'colRowH'}
                                                            align={'left'}
                                                            style={{ minWidth: 20, maxWidth: 30 }}
                                                        >
                                                            #
                                                        </TableCell>
                                          )}
                                            {columns.filter(c => c.show).map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{ minWidth: column.minWidth, maxWidth: column.maxWidth }}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {list && list.map((row, index) => {
                                            return (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={`user-row-${index}`}>
                                                     {this.state.showCount && (
                                                         <TableCell
                                                            key={`colRowH-${index}`}
                                                            align={'left'}
                                                            style={{ minWidth: 20, maxWidth: 30 }}
                                                        >
                                                            {index}
                                                        </TableCell>
                                          )}  
                                                    {columns.filter(c => c.show).map((column) => {
                                                        return (
                                                            <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth, maxWidth: column.maxWidth, wordBreak: 'break-word'}}>
                                                                {this.renderCell(row, column.id)}
                                                                
                                                            </TableCell>  
                                                        );
                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={pageSizeOptions}
                                component="div"
                                count={totalUsers}
                                rowsPerPage={pageSize}
                                page={page - 1}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                            {/* end of not isLoading */}
                        </span>
                    }
                </div>
            {/* Dialogs */}
                {/* ROW MENU */}
                <Menu
                    id="row-menu"
                    anchorEl={this.state.rowAnchorEl}
                    open={Boolean(this.state.rowAnchorEl)}
                    onClose={this.closeRowMenu}
                >
                    <MenuItem onClick={this.editProfile}>Edit Profile</MenuItem>
                    <MenuItem onClick={this.editSubscription}>Edit Subscription</MenuItem>
                    <MenuItem onClick={this.openDeleteUser}>Delete User</MenuItem>
                    <MenuItem onClick={this.openResetPW}>Reset Password</MenuItem>
                    <MenuItem disabled={this.isSubscribed('regenag-101')} onClick={() => {this.impersonate('regenag-101')}}>Regen Ag 101 Progress</MenuItem>
                    <MenuItem disabled={this.isSubscribed('grazing')} onClick={() => {this.impersonate('grazing')}}>Grazing Progress</MenuItem>
                  
                </Menu>
                {/* EDIT PROFILE */}
                {this.state.openEditDialog && 
                    <EditProfileDialog 
                        open={this.state.openEditDialog}
                        close={this.handleClose}
                        classes={classes}
                        data={this.state.rowContext}
                        columns={this.state.columns}
                        updateProfile={this.updateProfile}
                        memberGroups={this.state.memberGroups} 
                        memberTypes={this.state.memberTypes}
                    />
                }
                {/* EDIT SBUSCRIPTION */}
                {this.state.openSubDialog && 
                    <EditSubscriptionDialog
                        open={this.state.openSubDialog}
                        close={this.handleClose}
                        classes={classes}
                        courses={this.state.courses}
                        data={this.state.rowContext.organization_subscriptions}
                        updateSubscription={this.updateSubscription}
                        user={user}
                        byName={this.state.byName}
                    />
                }
                {/* EDIT PASSWORD */}
                {this.state.openPWDialog && (
                    <Dialog open={this.state.openPWDialog} onClose={this.handlePWClose}>
                        <DialogTitle>Reset User Password</DialogTitle>
                        <DialogContent>
                            Change password to '{this.state.changePasswordTo}' for {this.state.rowContext.email}.
                            <br /><br />
                            Are you sure you wish to reset {this.state.rowContext.email}'s pw?
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handlePWClose}>Cancel</Button>
                            <Button onClick={() => (this.resetPW(this.state.rowContext.email))} autoFocus color="primary">Reset Password</Button>
                        </DialogActions>
                    </Dialog>
                )}
                {/* DELETE USER */}
                {this.state.deleteOpen && this.state.rowContext && (
                    <Dialog open={this.state.deleteOpen} onClose={this.handleDeleteClose}>
                        <DialogTitle><span style={{ color: 'red' }}>Delete User {this.state.rowContext.email}</span></DialogTitle>
                        <DialogContent>
                            Confirm you would like to delete user with email: {this.state.rowContext.email}.
                            <br /><br />
                           Enter "<b>Delete this user</b>" below, then click the Delete User button:
                           <div style={{ width: 250, margin: '36px auto' }}>
                                <TextField
                                    id="delete-this-user"
                                    //   label="Enter Delete this user"
                                    style={{ margin: 8 }}
                                    placeholder="Type: Delete this user"
                                    fullWidth
                                    value={this.state.confirmMessage}
                                    onChange={this.handleDeleteInput}
                                    margin="normal"
                                //   InputLabelProps={{
                                //     shrink: true,
                                //   }}
                                />
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleDeleteClose}>Cancel</Button>
                            <Button 
                            onClick={this.doDeleteUser} 
                            disabled={this.state.confirmMessage !== 'Delete this user'}
                            variant='contained'
                            autoFocus color="primary">Delete User</Button>
                        </DialogActions>
                    </Dialog>
                )}
                {/* Processing CSV */}
               {this.state.processingCSV && (
                    <Dialog open={this.state.processingCSV}>
                        <DialogTitle>Processing. Please hold on a sec.</DialogTitle>
                        <DialogContent>
                           <LinearProgress style={{margin: 16}} value={this.state.csvProgress}/>
                            <h3 style={{margin: 32, fontFamily: 'sans-serif'}}>Creating CSV for download. {this.state.csvProgress}%</h3>
                          
                        </DialogContent>
                    </Dialog>
                )}
                {/* ADD USER */}
                {this.state.openAdd && (
                    <AddUserForm classes={classes} onClose={this.closeAddUser} memberGroups={this.state.memberGroups} memberTypes={this.state.memberTypes}/>
                )}
                {/* Bulk Upload Modal */}
                {this.state.openBulk && (
                    <BulkUploadForm openBulk={this.state.openBulk} setBulkOpen={this.closeBulk} apiManager={apiManager} org classes={classes} uploadedBy={this.state.byName} openSnack={this.openSnack} getList={this.getList}/>)}
                {this.renderMessage()}
                {this.state.showUsageReportDialog && (
                  <UsageReportDialog downloadCSV={this.callbackDownloadCSV} onClose={() => {this.setState({showUsageReportDialog: false})}} />
                )}
                <RegisterSnackBar
                    isOpen={this.state.snack.isOpen}
                    isSuccessfull={this.state.snack.isSuccessfull}
                    message={this.state.snack.message}
                    closeModal={this.closeSnack}
                />
            </div>
        );
    }
}

Administration.propTypes = {
    classes: PropTypes.object.isRequired,
    user: PropTypes.object,
    apiManager: PropTypes.object,
};

export default withStyles(styles)(Administration);
